module.exports = __webpack_public_path__ + "media/images/client-planet-fitness-da58400ed9f50da4679f84642db7a4f5.png";